import { ModuleConfig } from '@/core/module';
import { syncMonitoringRoutes } from './routes';

export const SyncMonitoringModule: ModuleConfig = {
    name: 'sync-monitoring',
    routes: syncMonitoringRoutes,
    initialize: () => {
        console.log('Sync Monitoring module initialized');
    },
};
